import { useApi } from '@/shared/api/http';
import type { BannerResponse } from '@/pages/home/ui/bannerSliderSection/model/types/banner';
import type { BannersService } from '../model/types';

export const useBannersService = (): BannersService => {
  const api = useApi();

  const getBanners = async (isAuth = false) => {
    try {
      return await api.get<BannerResponse>('/banners/', isAuth);
    } catch (error) {
      console.error('Ошибка при получении баннера:', error);
      throw error;
    }
  };

  return {
    getBanners,
  };
};
